<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Move Projects</h3>
</div>
<div class="modal-body clearfix">
  <div
    class="holder"
    [ngClass]="{
      'pick-session': state === 'pick-session',
    }">
    <div class="inner">
      <div class="ideas">
        <p>Pick the projects you want to move:</p>
        <idea-picker [(picked)]="pickedIdeas" [session]="session"></idea-picker>
      </div>
      <div class="sessions">
        <div class="top">
          <p>Choose the topic you want to move the projects to:</p>
          <div
            class="session-card"
            *ngFor="let session of targetSessions"
            [ngClass]="{
              picked: pickedSession === session,
              deactive: session.config.deactivated,
            }"
            (click)="pickedSession = session">
            <div class="session-info">
              <div class="title">{{ session.config.title }}</div>
              <div class="one-liner">{{ session.config.one_liner }}</div>
            </div>
            <div class="session-image">
              <div
                class="deactive-indicator"
                *ngIf="session.config.deactivated">
                Not Active
              </div>
              <img
                alt
                [src]="
                  session.config.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
              <div class="pick-overlay">
                <div class="pin">
                  <img alt src="assets/icons/picked.svg" />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="targetSessions.length === 0" class="empty">
            <img alt src="/assets/images/empty-row.svg" />
            <p>
              There are no topics to which you are allowed to move projects to.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button
        [disabled]="pickedIdeas.length === 0"
        class="btn"
        [ngClass]="{
          'btn-primary': pickedIdeas.length > 0,
        }"
        (click)="pickSession()"
        *ngIf="state === 'pick-ideas'">
        Choose Topic
      </button>

      <ng-container *ngIf="state === 'pick-session'">
        <button
          class="btn"
          *ngIf="target === 'workflow'"
          (click)="target = 'all'">
          See All Potential Topics
        </button>
        <button
          class="btn"
          *ngIf="target === 'all'"
          (click)="target = 'workflow'">
          See Targets from Workflow
        </button>
        <button class="btn" (click)="pickIdeas()">Modify Projects</button>
        <button
          [disabled]="pickedIdeas.length === 0 || !pickedSession || moving"
          class="btn"
          [ngClass]="{
            'btn-primary': pickedIdeas.length > 0 && pickedSession,
          }"
          (click)="moveIdeas()">
          <span *ngIf="pickedIdeas.length > 1">
            Move {{ pickedIdeas.length }} Projects to
            {{ pickedSession?.config.title }}
          </span>
          <span *ngIf="pickedIdeas.length === 1">
            Move 1 Project to {{ pickedSession?.config.title }}
          </span>
        </button>
      </ng-container>
    </div>
  </div>
</div>
